/*
  Multirow "Load image only near view" (sections/multirow.liquid): the image's
  src/srcset wait in data-near-view-src / data-near-view-srcset and are set
  once the image is within 400px of the screen. Used for large animated images
  that the browser's loading="lazy" would still fetch during page load.
  Nymock addition.
*/
(function () {
  const load = (img) => {
    if (img.dataset.nearViewSrcset) img.srcset = img.dataset.nearViewSrcset;
    img.src = img.dataset.nearViewSrc;
    img.removeAttribute('data-near-view-src');
    img.removeAttribute('data-near-view-srcset');
  };

  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) =>
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              observer.unobserve(entry.target);
              load(entry.target);
            }),
          { rootMargin: '400px 0px' }
        )
      : null;

  const watch = (root) =>
    root.querySelectorAll('img[data-near-view-src]').forEach((img) => (observer ? observer.observe(img) : load(img)));

  watch(document);
  document.addEventListener('shopify:section:load', (event) => watch(event.target));
})();
